// extracted by mini-css-extract-plugin
module.exports = {"box":"content-box-module--box--2m2kN","icon":"content-box-module--icon--2b-s_","content":"content-box-module--content--24mcb"};